<template>
  <div class="modal_wrap system ic_commonModal" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">월 선택</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="check_table" data-columns="">
              <label v-for="item in months" :key="item"
                ><input
                  type="radio"
                  :value="item"
                  v-model="selectedMonth"
                /><span>{{ item }}월 </span></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="close(false)">
              닫기
            </button>
            <button class="btn2" @click="close(true)">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonthModal',
  props: {
    show: Boolean,
    month: String,
  },
  data() {
    return {
      type: 'month',
      selectedMonth: '01',
    };
  },
  computed: {
    months() {
      let result = [];
      for (let i = 1; i <= 12; i++) {
        if (i < 10) {
          result.push('0' + i);
        } else {
          result.push(i.toString());
        }
      }
      return result;
    },
  },
  methods: {
    close(dataType) {
      if (!dataType && this.month) {
        this.selectedMonth = this.month;
      }
      this.$emit('close', dataType, this.selectedMonth);
    },
  },
};
</script>
